import { useState } from "react";

import { CreateGroupContext, initialGroupValues } from "./CreateGroupContext";
import { CreateGroupDetailsStep } from "./CreateGroupDetailsStep";
import { CreateGroupUsersStep } from "./CreateGroupUsersStep";

export function CreateGroupPage() {
  const [customerGroup, setCustomerGroup] = useState({
    ...initialGroupValues,
  });
  const [currentStep, setCurrentStep] = useState(0);

  const steps = [
    <CreateGroupDetailsStep key="1" />,
    <CreateGroupUsersStep key="2" />,
  ];

  const handleNext = () => {
    setCurrentStep((curr) => curr + 1);
  };

  const handlePrev = () => {
    setCurrentStep((curr) => curr - 1);
  };

  return (
    <CreateGroupContext.Provider
      value={{
        customerGroup,
        setCustomerGroup,
        goToNextStep: handleNext,
        goToPrevStep: handlePrev,
        currentStep,
        totalSteps: steps.length,
      }}
    >
      {steps[currentStep]}
    </CreateGroupContext.Provider>
  );
}
